// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = require("!!../../../app/node_modules/css-loader/dist/cjs.js?{\"sourceMap\":true}!../../../app/node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-5f49edb2\",\"scoped\":false,\"hasInlineConfig\":false}!../../../app/node_modules/vue-loader/lib/selector.js?type=styles&index=0!./exchange.vue");
if(typeof content === 'string') content = [[module.id, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = require("!../../../app/node_modules/vue-style-loader/lib/addStylesClient.js")("31be831c", content, false, {});
// Hot Module Replacement
if(module.hot) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../../app/node_modules/css-loader/dist/cjs.js?{\"sourceMap\":true}!../../../app/node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-5f49edb2\",\"scoped\":false,\"hasInlineConfig\":false}!../../../app/node_modules/vue-loader/lib/selector.js?type=styles&index=0!./exchange.vue", function() {
     var newContent = require("!!../../../app/node_modules/css-loader/dist/cjs.js?{\"sourceMap\":true}!../../../app/node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-5f49edb2\",\"scoped\":false,\"hasInlineConfig\":false}!../../../app/node_modules/vue-loader/lib/selector.js?type=styles&index=0!./exchange.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}


//////////////////
// WEBPACK FOOTER
// ../app/node_modules/vue-style-loader!../app/node_modules/css-loader/dist/cjs.js?{"sourceMap":true}!../app/node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-5f49edb2","scoped":false,"hasInlineConfig":false}!../app/node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/pages/exchange.vue
// module id = MbqR
// module chunks = 0